import {
	Component,
	ChangeDetectorRef,
	OnInit,
	ViewChild,
	ViewEncapsulation,
	AfterViewInit,
	OnDestroy,
	Inject
} from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { DOCUMENT } from '@angular/common';
import { SuiModal, ComponentModalConfig, ModalSize } from '@richardlt/ng2-semantic-ui';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormBuilderService } from '../../services';
import { Router } from '@angular/router';
import { AppFilter } from 'src/modules/shared';
import { SharedValidators } from 'src/modules/shared';
import { Subject } from 'rxjs';
import { takeUntil, distinctUntilChanged, map } from 'rxjs/operators';
import {
	XlsFormGroupModelInterface,
	XlsFormGenericInterface,
	XlsFormSelectModelInterface,
	XlsFormCalculateModelInterface,
	XlsFormRepeatModelInterface
} from '../../models';
interface IFieldModalContext {
	title?: string;
	fieldData?: any;
	fields?: any;
	isEdit: boolean;
}

@Component({
	selector: 'tamsy-field-modal',
	templateUrl: './field-modal.component.html',
	// encapsulation: ViewEncapsulation.None,
	styleUrls: [ './field-modal.component.scss' ]
})
export class FieldModalComponent implements OnDestroy {
	private unsubscribe$: Subject<void> = new Subject<void>();
	isImport: boolean;
	formGroup: FormGroup;
	modelForm: FormGroup;
	name: any;
	globalGrpid: any;
	globalIndex: number;

	genericModel: XlsFormGenericInterface;
	selectModel: XlsFormSelectModelInterface;
	groupModel: XlsFormGroupModelInterface;
	repeatModel: XlsFormRepeatModelInterface;
	calculateModel: XlsFormCalculateModelInterface;
	selectComponents: any[];
	fieldArrays: Array<any> = [];

	formSubmitAttempt: boolean;
	pending: boolean;
	success: any;
	error: any;
	isEdit: boolean;
	field;

	constructor(
		private formBuilderSvc: FormBuilderService,
		public modal: SuiModal<IFieldModalContext, void, void>,
		private _fb: FormBuilder,
		private router: Router,
		private ref: ChangeDetectorRef,
		@Inject(DOCUMENT) private document
	) {
		this.popForm();
		// this.selectModel = modal.context.fieldData;
		this.fieldArrays = modal.context.fields;
		// console.log(modal.context.fields);
		// console.log(modal.context.fieldData);
		this.isEdit = modal.context.isEdit;
		if (modal.context.fieldData) {
			this.modelForm.patchValue(modal.context.fieldData);
			this.modelChooser({ ...modal.context.fieldData });
		}
		// this.ref.markForCheck();

		this.formBuilderSvc.getChildGroup().subscribe((res) => {
			if (res) {
				console.log('In group', res);
				this.groupField(Object.assign({}, res));
				// this.modelChooser(Object.assign({}, res));
			}
		});
	}
	create() {}
	edit() {}

	// modal submit method
	modalSubmit($event) {
		if ($event.inputStyle === 'group' || $event.inputStyle === 'repeat') {
			$event['group'] = [];
		}
		// this.selectComponents = $event;
		let fieldname = this.modelForm.value.name;
		this.checkUnique(fieldname).then((res) => {
			if (res === 'true') {
				this.relevantCalculate();
				this.constriantCalculate();
				this.saveActual($event);
			} else if (res === 'false') {
			}
		});
	}

	modalEdit($event) {
		// console.log($event);
		let fieldname = $event;
		this.checkEditUnique(fieldname).then((res) => {
			// console.log(res);
			this.relevantCalculate();
			this.constriantCalculate();
			this.getEditModel($event);
		});
	}

	onEdit($event) {}

	// check for unique model name
	getEditModel(fieldname) {
		var obj: any = [ ...this.fieldArrays ];
		var arrayFlatten;
		arrayFlatten = function(arr) {
			for (let i = 0; i < arr.length; i++) {
				var items = { ...arr[i] };
				if (
					'group' in items &&
					typeof items['group'] !== 'undefined' &&
					items['group'] !== null &&
					items['group'].length > 0 &&
					fieldname.type !== 'group'
				) {
					arrayFlatten(items['group']);
				} else if (items['id'] === fieldname.id) {
					items.label = fieldname.label;
					items.name = fieldname.name;
					items.multi = fieldname.multi;
					items.required = fieldname.required;
					items.choices = fieldname.choices;
					items.hint = fieldname.hint;
					items.constraint = fieldname.constraint;
					items.constraint_message = fieldname.constraint_message;
					items.relevant = fieldname.relevant;
					items.relevantGroup = fieldname.relevantGroup;
					items.constraintGroup = fieldname.constraintGroup;

					if (fieldname.inputStyle === 'repeat') {
						items.repeatCount = fieldname.repeatCount;
					}
					arr[i] = items;
					// console.log(items);
				}
			}
		};
		arrayFlatten(obj);
		// this.store.dispatch(new XlsFormActions.XlsFormFieldEditSuccessAction(obj));
		// this.close();
		this.modal.approve(obj);
	}

	saveActual(modd: any) {
		if (modd.parentModel !== '' && modd.parentModel !== null && modd.parentModel !== undefined) {
			let arr: any = this.fieldArrays.slice();
			for (let i = 0; i < arr.length; i++) {
				if (arr[i].id === modd.parentModel) {
					arr[i]['group'].push(modd);
					break;
				}
			}
			this.modal.approve(arr);
		} else {
			let obj: any = this.fieldArrays;
			let isExist = this.fieldArrays.filter((filed) => filed.id == modd.id);

			if (isExist.length > 0) {
				for (let i = 0; i < obj.length; i++) {
					if (obj[i].id == modd.id) {
						obj[i] == modd;
					}
				}
			} else {
				obj.push(modd);
			}
			// this.store.dispatch(new XlsFormActions.XlsFormFieldSaveAction(modd));
			this.modal.approve(obj);
			// this.close();
		}
	}

	// modal close method
	modalClose($event) {
		this.modelForm.reset();
		this.modal.deny(undefined);
	}

	close() {
		// this.autoShownModal.hide();
		this.selectModel = null;
		this.calculateModel = null;
		this.groupModel = null;
		this.repeatModel = null;
		this.genericModel = null;
		this.modelForm.reset();
		// this.store.dispatch(new XlsFormActions.OnModalCloseAction(''));
		this.modal.deny(null);
	}

	groupField(event) {
		let model = event.model;
		let id = event.group;
		this.globalGrpid = id;
		console.log('SETTING GLOBLID', this.globalGrpid);
		let arr = this.fieldArrays;
		for (let i = 0; i < arr.length; i++) {
			if (arr[i].id === id) {
				this.globalIndex = i;
			}
		}
		this.groupModel = null;

		this.modelForm.patchValue(model);
		this.modelChooser(Object.assign({}, model));
		console.log('After GLOBLID', this.globalGrpid);
	}

	modalUp(event) {}

	// event handler for the field drop
	modelChooser(model) {
		switch (model.inputStyle) {
			case 'select_one':
				this.selectModel = model;
				break;
			case 'select_multiple':
				this.selectModel = model;
				break;
			case 'calculate':
				this.calculateModel = model;
				break;
			case 'group':
				this.groupModel = model;
				break;
			case 'repeat':
				this.groupModel = model;
				break;
			default:
				this.genericModel = model;
		}
		console.log(this.genericModel);
		this.populateSelect(model);
		setTimeout(() => {
			this.error = false;
			//   this.autoShownModal.show();
		}, 500);
	}

	popForm() {
		this.modelForm = this._fb.group({
			id: [],
			name: [ '', [ Validators.required, SharedValidators.columnName ] ],
			label: [ '', Validators.required ],
			hint: [ '' ],
			required: [ '' ],
			parentModel: [],
			relevant: [ '' ],
			constraint: [ '' ],
			inputStyle: [],
			type: [],
			control: [],
			constraint_message: [ '' ],
			constraintGroup: this._fb.group({
				constStatus: [ '' ],
				// constValue: [ '', SharedValidators.columnName ],
				constValue: [ '' ],
				constOperator: [ '=' ]
			}),
			relevantGroup: this._fb.group({
				relStatus: [ '' ],
				relComp: [ '' ],
				relValue: [ '' ],
				// relValue: [ '', SharedValidators.columnName ],
				relOperator: [ '=' ]
			}),
			choices: [],
			calculation: [],
			multi: [ '' ],
			repeatCount: [ '' ]
		});
	}

	// check for unique model name
	populateSelect(model) {
		let count = [];
		let arr = this.fieldArrays;
		if (arr.length > 0) {
			var arrayFlatten;
			arrayFlatten = function(arr) {
				for (let i = 0; i < arr.length; i++) {
					let items = arr[i];
					// console.log(items)
					if (
						'group' in items &&
						typeof items['group'] !== 'undefined' &&
						items['group'] !== null &&
						items['group'].length > 0
					) {
						arrayFlatten(items['group']);
					} else {
						if (items.name !== model.name) {
							count.push({ id: items.id, field: items.name, type: items.inputStyle });
						}
					}
				}
			};
			arrayFlatten(arr);
			console.log(count);
			this.selectComponents = count;
		}
		return count;
	}

	// compute relevant field
	relevantCalculate() {
		// console.log(this.fieldArrays)

		let recomp = this.modelForm.value.relevantGroup.relComp;
		let relvalue = this.modelForm.value.relevantGroup.relValue;
		let relOpera = this.modelForm.value.relevantGroup.relOperator;
		let type = this.fieldArrays.filter((x) => x.field === recomp);
		if (type.length > 0) {
			if (recomp && relvalue != '' && type[0].type != 'select_multiple') {
				this.modelForm.value.relevant = '${' + recomp + '}' + relOpera + "'" + relvalue + "'";
			} else if (recomp && relvalue != '' && type[0].type === 'select_multiple') {
				this.modelForm.value.relevant = 'selected(${' + recomp + "}, '" + relvalue + "')";
			}
		}
	}

	// compute constraint field
	constriantCalculate() {
		let constStatus = this.modelForm.value.constraintGroup.constStatus;
		let constValue = this.modelForm.value.constraintGroup.constValue;
		let constOperator = this.modelForm.value.constraintGroup.constOperator;
		let vr;
		if (constValue && constValue.substring) {
			vr = "'" + constValue + "'";
		} else {
			vr = constValue;
		}
		if (constValue && constOperator && constStatus === 'true') {
			this.modelForm.value.constraint = '.' + constOperator + vr;
		}
		return;
	}

	// check for unique model name
	checkUnique(fieldname): Promise<any> {
		return new Promise((resolve, reject) => {
			let count = [];
			var arrayFlatten;
			arrayFlatten = function(arr) {
				for (let i = 0; i < arr.length; i++) {
					let items = arr[i];
					if (
						'group' in items &&
						typeof items['group'] !== 'undefined' &&
						items['group'] !== null &&
						items['group'].length > 0
					) {
						arrayFlatten(items['group']);
					} else if (items['name'] === fieldname) {
						count.push(items);
						// console.log(items)
					}
				}
			};
			arrayFlatten(this.fieldArrays);
			if (count.length > 0) {
				this.error = true;
				reject('false');
			} else {
				this.error = false;
				resolve('true');
			}
		});
	}

	checkEditUnique(fieldname): Promise<any> {
		return new Promise((resolve, reject) => {
			let count = [];
			var arrayFlatten;
			arrayFlatten = function(arr) {
				for (let i = 0; i < arr.length; i++) {
					let items = arr[i];
					if (
						'group' in items &&
						typeof items['group'] !== 'undefined' &&
						items['group'] !== null &&
						items['group'].length > 0
					) {
						arrayFlatten(items['group']);
					} else if (items['name'] === fieldname.name && items['id'] !== fieldname.id) {
						count.push(items);
						// console.log(items)
					}
				}
			};
			arrayFlatten(this.fieldArrays);
			if (count.length > 0) {
				this.error = true;
				reject('false');
			} else {
				this.error = false;
				resolve('true');
			}
		});
	}

	cloneField(fieldname) {
		let obj = this.fieldArrays;
		var arrayFlatten;
		arrayFlatten = function(arr) {
			for (let i = 0; i < arr.length; i++) {
				let items = arr[i];
				if (
					'group' in items &&
					typeof items['group'] !== 'undefined' &&
					items['group'] !== null &&
					items['group'].length > 0 &&
					fieldname.type !== 'group'
				) {
					arrayFlatten(items['group']);
				} else if (
					items['name'] === fieldname.name &&
					fieldname.type === 'group' &&
					items['group'].length > 0
				) {
					let relname = Math.random().toString(36).substr(2, 5);
					let oj = fieldname.name;
					let name = `${oj}_${relname}`;
					let newObj = JSON.parse(JSON.stringify(fieldname));
					newObj.id = name;
					newObj.name = name;
					let grp = newObj['group'];
					// loop through children and recreate id,name and parentModel properties value
					for (let x = 0; x < grp.length; x++) {
						let relname = Math.random().toString(36).substr(2, 5);
						let name = grp[x].name;
						grp[x].id = `${name}_${relname}`;
						grp[x].label = `${name}_${relname}`;
						grp[x].name = `${name}_${relname}`;
						grp[x].parentModel = `${newObj.id}`;
					}
					// console.log(newObj);
					let idx = i + 1;
					arr.splice(idx, 0, newObj);
					return arr;
				} else if (items['name'] === fieldname.name) {
					let relname = Math.random().toString(36).substr(2, 5);
					let oj = fieldname.name;
					let name = `${oj}_${relname}`;
					let newObj = JSON.parse(JSON.stringify(fieldname));
					newObj.id = name;
					newObj.label = name;
					newObj.name = name;
					// console.log(newObj);
					let idx = i + 1;
					arr.splice(idx, 0, newObj);
					return arr;
				}
			}
		};
		arrayFlatten(obj);
		// this.store.dispatch(new XlsFormActions.XlsFormFieldClonedAction(obj))
	}

	deleteField(xlsForm_Field) {
		let newarr = Object.assign(this.fieldArrays);
		var arrayFlatten;
		arrayFlatten = function(arr) {
			// console.log('havoc')
			for (let i = 0; i < arr.length; i++) {
				let items = arr[i];
				if (items['name'] === xlsForm_Field.name) {
					arr.splice(i, 1);
					// console.log(arr)
				} else if (
					'group' in items &&
					typeof items['group'] !== 'undefined' &&
					items['group'] !== null &&
					items['group'].length > 0 &&
					xlsForm_Field.type !== 'group'
				) {
					arrayFlatten(items['group']);
				}
			}
		};
		arrayFlatten(newarr);
		// console.log(newarr)
		// this.store.dispatch(new XlsFormActions.XlsFormFieldDeleteSuccessAction(newarr));
	}

	nullify() {
		this.success = null;
		this.error = null;
	}

	ngOnDestroy(): void {
		// unsubscribe all subsciptons
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}
}

export class FieldModal extends ComponentModalConfig<IFieldModalContext, void, void> {
	constructor(title, fieldData: any, fields, isEdit: boolean, size: ModalSize = ModalSize.Small) {
		super(FieldModalComponent, { title, fieldData, fields, isEdit });

		this.isClosable = false;
		this.transitionDuration = 400;
		this.size = size;
		this.isFullScreen = false;
		this.isInverted = false;
		this.transition = 'slide left';
		this.mustScroll = true;
		// this.
		// this.
	}
}
